import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Table,
  Badge,
  Button,
  Form,
  Modal,
} from "react-bootstrap";
import { Eye, CheckCircle, XCircle, Edit, Search } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { FaEye, FaSearch } from "react-icons/fa";
import { Baseurl } from "../../baseurl";
import axios from "axios";

const ApprovedAgencies = () => {
  const [agencies, setAgencies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredAgencies, setFilteredAgencies] = useState([]);
  const navigate = useNavigate();

  // Mock data - Replace with actual API call
  useEffect(() => {
    // Fetch Approved agencies from API
    const fetchPendingAgencies = async () => {
      try {
        const url = `${Baseurl}/api/agency/approved`;
        const resp = await axios.get(url);
        if (resp.data.data) {
          setAgencies(resp.data.data);
          setFilteredAgencies(resp.data.data);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching agencies:", error);
        setLoading(false);
      }
    };

    fetchPendingAgencies();
  }, []);

  useEffect(() => {
    const filtered = agencies.filter(
      (agency) =>
        agency.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        agency.applicationID.toLowerCase().includes(searchTerm.toLowerCase()) ||
        agency.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
        agency.companyDetails?.companyName
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase()),
    );
    setFilteredAgencies(filtered);
  }, [searchTerm, agencies]);

  const handleViewDetails = (id) => {
    navigate(`/agencies/agency-details/${id}`);
  };

  const getStatusBadge = (status) => {
    const variants = {
      Pending: "warning",
      Approved: "success",
      Rework: "info",
      Rejected: "danger",
    };
    return <Badge bg={variants[status]}>{status}</Badge>;
  };

  if (loading) {
    return (
      <Container className="mt-5">
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </Container>
    );
  }

  return (
    <Container fluid className="mt-4">
      <Row className="mb-4">
        <Col>
          <h3 className="text-primary">
            <FaEye className="me-2" />
            Approved Agency Applications
          </h3>
          <p className="text-muted">Review and manage agency applications</p>
        </Col>
      </Row>

      <Card className="shadow-sm">
        <Card.Header className="bg-light d-flex justify-content-between align-items-center">
          <h5 className="mb-0">
            Approved Applications ({filteredAgencies.length})
          </h5>
          <div className="d-flex" style={{ width: "300px" }}>
            <div className="input-group">
              <span className="input-group-text">
                <FaSearch />
              </span>
              <Form.Control
                type="text"
                placeholder="Search by name, application ID, or company..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
        </Card.Header>
        <Card.Body>
          {filteredAgencies.length === 0 ? (
            <div className="text-center py-5">
              <p className="text-muted">No Approved agencies found</p>
            </div>
          ) : (
            <div className="table-responsive">
              <Table hover className="align-middle">
                <thead className="table-light">
                  <tr>
                    <th>Application ID</th>
                    <th>Agency Name</th>
                    <th>Company Name</th>
                    <th>Contact Details</th>
                    <th>Applied Date</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredAgencies.map((agency) => (
                    <tr key={agency._id}>
                      <td>
                        <strong>{agency.applicationID}</strong>
                      </td>
                      <td>{agency.name}</td>
                      <td>{agency.companyDetails?.companyName || "N/A"}</td>
                      <td>
                        <div>{agency.email}</div>
                        <small className="text-muted">{agency.mobileNo}</small>
                      </td>
                      <td>{new Date(agency.createdAt).toLocaleDateString()}</td>
                      <td>{getStatusBadge(agency.agencyStatus)}</td>
                      <td>
                        <Button
                          variant="outline-primary"
                          size="sm"
                          onClick={() => handleViewDetails(agency._id)}
                          className="me-2"
                        >
                          <FaEye className="me-1" /> View Details
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default ApprovedAgencies;
